<template functional>
    <div class="form-group">
        <label class="text-bold-600" style="display: block">&nbsp;</label>
        <btn :class="data.staticClass"
             v-on:click="listeners.click && listeners.click()"
             :disabled="props.disabled"
             :readonly="props.readonly"
        >
            <slot></slot>
        </btn>
    </div>
</template>

<script>

export default {
    name: 'FormBtn',
};
</script>
